export default __webpack_public_path__ + "static/media/08-plaza-loiza.bda7373a.png";